import React from 'react';
import { IconProps } from './types';

const Wand2: React.FC<IconProps> = ({
  className,
  size = 32,
  color = '#181b32',
  ignoreColor,
}) => (
  <svg
    viewBox="0 0 16 16"
    className={className}
    width={1 * size}
    height={1 * size}
  >
    <path
      d="M11.077 0H9.65v2.854h1.427V0zM11.077 8.323H9.65v2.616h1.427V8.323zM15.83 4.756h-2.853v1.427h2.853V4.756zM7.747 4.756H5.13v1.427h2.616V4.756zM13.729 1.035l-1.967 1.967 1.009 1.01 1.967-1.968-1.009-1.01zM8.02 6.97L0 14.991 1.009 16l8.02-8.02-1.008-1.01zM12.566 7.021l-1.01 1.009 1.968 1.967 1.009-1.009-1.967-1.967zM7.08 1.038L6.07 2.046l1.968 1.968 1.009-1.01-1.968-1.966z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default Wand2;
